export function disableRightClick() {
  $(document).on("contextmenu", ".no-contextmenu, .fancybox-image", function(
    e
  ) {
    e.preventDefault();
  });
}
